// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"b17cd2bd","787":"299a92ab"}[chunkId] + ".chunk.js";
};